import useOrganizationData from "hooks/organizaton/useOrganization";
import useBankDetails from "../../api/useOrganizationBankData";
import { useMemo } from "react";

const { Text } = require("@chakra-ui/react");

const BankDetails = () => {

  const { organizationData } = useOrganizationData();
  const orgBank = useBankDetails();

  const bankDetail = useMemo(()=>{
    if(organizationData?.isBnk){
      if(organizationData?.bnk?.typ === 'auto'){
        return orgBank
      }
      else{
        return organizationData?.bnk;
      }
    }
    return null
  },[orgBank,organizationData])

  return (
    <>
      {bankDetail && (
        <div className="bank-details-container">
          <Text className="fw-600">Bank Account Information:</Text>
          <Text className="terms-text">
            {bankDetail?.name} - {bankDetail?.bch}
          </Text>
          <Text className="terms-text">
            Account Number: {bankDetail?.acNo}, IFSC: {bankDetail?.ifc}
          </Text>
        </div>
      )}
    </>
  );
};

export default BankDetails;
